// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyField_wrapper__HAcj2","value":"CopyField_value__O2mMv","copyImage":"CopyField_copyImage__0O8PX"};